import React, { useState, useEffect, } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//inview
import { useInView } from 'react-intersection-observer';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/style/user.mypage.module.scss';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import SubTitleBar from 'src/webapp/views/component/title/SubTitleBar';//서브타이틀
import EmptyData from 'src/webapp/views/component/EmptyData';//데이터없음
import NoticeRegAndUpdate from '../bottomsheet/NoticeRegAndUpdate';//공지사항 등록 & 수정 & 삭제 - bottomsheet

export default React.memo(function NoticeList(props) {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { isState, partner } = usePartnerStore();//store

    /* =============== 공지사항리스트 최초로딩 =============== */
    const [ inViewRef, inView ] = useInView({ threshold: .3 });
    useEffect(() => {
        if(!isState || !inView || boardList.length > 0) { return; }

        boardListAPI();//공지사항리스트API
    }, [inView]);
    /* =============== 공지사항리스트 최초로딩 =============== */
    /* =============== 공지사항리스트 =============== */
    //공지사항리스트API
    const [ boardList, setBoardList ] = useState([]);
    const boardListAPI = async() => {
        const DATA = { PARTNER_CD:partner.COMN_CD };
        const result = await axiosPostHandler(`partnerBoardListForPartner.do`, DATA);
        if(!result) { return; }
        if(result.message === "SUCCESS") { setBoardList(result.data); }
    };
    /* =============== 공지사항리스트 =============== */
    /* =============== 공지사항 등록 & 수정 & 삭제 팝업오픈여부 =============== */
    const [ isOpen,setOpen ] = useState(false);
    const [ item,setItem ] = useState(null);
    const onDismissHandler = (value, data) => {
        setItem(data);
        setOpen(value);
    }
    /* =============== 공지사항 등록 & 수정 & 삭제 팝업오픈여부 =============== */

    return (
        <>
        <Element tag={`div`} propRef={inViewRef} className={styles.noticeContainer}>
            <SubTitleBar title={`공지사항(${boardList.length})`}>
                <button onClick={(e) => onDismissHandler(true, null)}><FontAwesomeIcon icon="fa-light fa-plus" /><span>등록하기</span></button>
            </SubTitleBar>
            {boardList.length > 0 ?
                <Element tag={`ul`}>
                    {boardList.map((item, idx) => 
                        <Element tag={`li`} key={idx}>
                            <Element tag={`div`}>
                                <Element tag={`h1`}>{item.SUBJECT}</Element>
                                <Element tag={`p`}>{item.CONTENT}</Element>
                            </Element>
                            <Element tag={`button`} anyprop={(e) => onDismissHandler(true, item)}><FontAwesomeIcon icon="fa-light fa-pen-line" /></Element>
                        </Element>
                    )}
                </Element>
            : <Element tag={`div`} className={styles.emptyData}><EmptyData content={`공지사항은`} /></Element> }
        </Element>
        {/* 공지사항 등록 & 수정 & 삭제 bottomsheet */}
        {isOpen ? <NoticeRegAndUpdate isOpen={isOpen} data={item} boardList={boardList} setBoardList={setBoardList} onDismiss={onDismissHandler} /> : null}
        </>
    );
})